var React = require('react');

function GalleryPrevButton (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.17119 4.3438c-.236603.23661-.236603.62022 0 .85683l3.85574 3.85574c.23661.2366.62022.2366.85683 0 .23661-.23661.23661-.62023 0-.85683L2.45644 4.77222 5.88376 1.3449c.23661-.23661.23661-.620226 0-.856833-.23661-.236607-.62022-.236607-.85683 0L1.17119 4.3438Zm.42842 1.03429H19.3718V4.16635H1.59961v1.21174Z","fill":"#194550"}));
}

GalleryPrevButton.defaultProps = {"fill":"none","viewBox":"0 0 20 10"};

module.exports = GalleryPrevButton;

GalleryPrevButton.default = GalleryPrevButton;
